export const ENCYCLOPEDIA_LOG_EVENT = {
  CLICK_OUTER_LINK: 'click_outer_link',
} as const;
